import { useMemo } from "react";
import { useRabbitFestivalContext } from "../../../../hooks/festival-context";
import {
  FestivalEventInfoContent,
  FestivalEventInfoItem,
  FestivalEventInfoWrapper,
} from "./style";
import { formatDateWithDay } from "../../../../../../../utils/date";

const RabbitFestivalEventInfo = () => {
  const { event } = useRabbitFestivalContext();

  const getTime = (value: string) => {
    const date = new Date(value);
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const isPM = hours >= 12;

    hours = hours % 12;
    if (hours === 0) hours = 12;

    return `${isPM ? "오후" : "오전"} ${hours}:${minutes
      .toString()
      .padStart(2, "0")}`;
  };

  const infoList = useMemo(() => {
    if (!event) return;
    const tournament = event?.tournament;

    const state =
      tournament?.timeInfo?.elapsedTimeMs < 0
        ? "진행예정"
        : tournament.isEnd
          ? "종료"
          : "진행중";

    const totalValue = tournament.moneyInChip.reduce(
      (sum, item) => sum + item.point,
      0,
    );

    const duration = tournament.structure.map((item) => {
      if (item.level !== null) return item.time;
      return 0;
    });
    const durationArr = duration.reduce<number[]>((acc, curr) => {
      if (!acc.includes(curr) && curr !== 0) acc.push(curr);
      return acc.sort((a, b) => b - a);
    }, []);

    return [
      { name: "상태", value: state },
      { name: "토탈 프라이즈", value: `${totalValue?.toLocaleString()} GTD` },
      { name: "날짜", value: formatDateWithDay(tournament.startDate) },
      { name: "시간", value: getTime(tournament.startDate) },
      {
        name: "바이인",
        value: `${((tournament.buyIn || 0) / 10000)?.toLocaleString()} RABBIT`,
      },
      { name: "레지 마감", value: `${tournament.registerDeadlineLevel}LV` },
      { name: "스타팅 칩", value: tournament.buyInChip?.toLocaleString() },
      { name: "리엔트리 칩", value: tournament.reBuyInChip?.toLocaleString() },
      { name: "듀레이션", value: `${durationArr.join("/")}분` },
    ];
  }, [event]);

  return (
    <FestivalEventInfoWrapper>
      <div className="title">GAME INFORMATION</div>
      <FestivalEventInfoContent>
        {infoList?.map((item, index) => (
          <FestivalEventInfoItem key={index}>
            <div className="name">{item.name}</div>
            <div className="value">{item.value}</div>
          </FestivalEventInfoItem>
        ))}
      </FestivalEventInfoContent>
    </FestivalEventInfoWrapper>
  );
};

export default RabbitFestivalEventInfo;
